/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/credit_line';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "SetPrimaryPaymentAccountRequest": {
                "fields": {
                  "creditLineId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "primaryPaymentAccountToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SetPrimaryPaymentAccountResponse": {
                "fields": {
                  "paymentAccounts": {
                    "type": ".squareup.corporate_card.resources.CreditLine.PaymentAccount",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SetPrimaryPaymentAccountRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SetPrimaryPaymentAccountResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SetPrimaryPaymentAccountRequest @ squareup/corporate_card/service/set_primary_payment_account.proto at 10:1
 */
export const SetPrimaryPaymentAccountRequest = $root.lookupType('squareup.corporate_card.service.SetPrimaryPaymentAccountRequest');
fixType(SetPrimaryPaymentAccountRequest, {
  creditLineId: {
    notEmpty: true
  },
  primaryPaymentAccountToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SetPrimaryPaymentAccountRequest);
/**
 * SOURCE SetPrimaryPaymentAccountResponse @ squareup/corporate_card/service/set_primary_payment_account.proto at 24:1
 */
export const SetPrimaryPaymentAccountResponse = $root.lookupType('squareup.corporate_card.service.SetPrimaryPaymentAccountResponse');
fixType(SetPrimaryPaymentAccountResponse);
Builder.createAndAttachToType(SetPrimaryPaymentAccountResponse);